import React, { useState } from 'react';
import Wrapper from './Wrapper';
import logo from '../assets/images/logo.svg';
import i18n from 'i18next';

export default function Header() {
    var [showMenu, toggleMenu] = useState(false);

    return (
        <header>
            <div className="bg-primary-green mb-6 lg:mb-8">
                <Wrapper>
                    <p className="text-white text-right py-3">
                        <i className="fas fa-envelope mr-1"></i> <a href="mailto:infopl@airproducts.com" className="hover:underline">{i18n.t('info_mail')}</a>
                    </p>
                </Wrapper>
            </div>
            <Wrapper>
                <nav className="lg:flex lg:items-center lg:justify-between">
                    <div className="flex items-center justify-between">
                        <a href="https://www.airproducts.com.pl" target="_blank"><img src={logo} alt="The Air Products logo" /></a>
                        <a href="tel:801081122" className="lg:hidden text-primary-green text-2xl ml-auto mr-5"><i className="fas fa-phone-alt"></i></a>
                        <a onClick={(e) => {e.preventDefault(); toggleMenu(!showMenu)}} href="#" className="lg:hidden text-primary-green text-3xl"><i className="fal fa-bars"></i></a>
                    </div>
                    <ul className={(showMenu ? 'block' : 'hidden') + " lg:block lg:flex lg:items-center lg:justify-between text-right lg:text-center pt-6 lg:pt-0"}>
                        <li className="mb-4 lg:mb-0 lg:mr-8"><a href="https://www.airproducts.com.pl/gases/bip-range" className="inline-block text-primary-green font-bold hover:underline"  target="_blank">Gazy w butlach BIP®</a></li>
                        <li className="mb-4 lg:mb-0 lg:mr-8"><a href="https://www.airproducts.com.pl/gases/bip-range/bip-faqs" className="inline-block text-primary-green font-bold hover:underline"  target="_blank">{i18n.t('menu_faq')}</a></li>
                        <li className="mb-4 lg:mb-0 lg:mr-8"><a href="https://airproducts-pl.custhelp.com/app/ask" className="inline-block text-primary-blue font-bold hover:underline"  target="_blank">Kontakt</a></li>
                    </ul>
                </nav>
            </Wrapper>
        </header>
    );
}